import { Controller } from "@hotwired/stimulus"
import { patch, destroy } from "@rails/request.js"

export default class extends Controller {
  static targets = ["metricName", "metricValue", "editForm", "nameInput", "valueInput",
                     "formatSelect", "previousInput", "targetInput", "unitInput", "deleteButton"]
  static values = { cardId: String }

  edit(event) {
    event.preventDefault()
    event.stopPropagation()

    // Populate form with current values
    if (this.hasNameInputTarget) {
      this.nameInputTarget.value = this.metricNameTarget.textContent.trim()
    }
    if (this.hasValueInputTarget && this.metricValueTarget.dataset.rawValue) {
      this.valueInputTarget.value = this.metricValueTarget.dataset.rawValue
    }

    this.element.querySelectorAll("[data-journey-map-metric-card-target='metricName'], [data-journey-map-metric-card-target='metricValue']").forEach(el => {
      el.closest("div")?.classList.add("hidden")
    })

    // Hide display elements, show edit form
    this.editFormTarget.classList.remove("hidden")
    if (this.hasDeleteButtonTarget) this.deleteButtonTarget.classList.add("hidden")
    this.nameInputTarget.focus()
  }

  cancel() {
    this.editFormTarget.classList.add("hidden")
    this.element.querySelectorAll(".hidden[data-journey-map-metric-card-target]").forEach(el => {
      // Don't unhide the edit form
      if (el !== this.editFormTarget) {
        el.closest("div")?.classList.remove("hidden")
      }
    })
    if (this.hasDeleteButtonTarget) this.deleteButtonTarget.classList.remove("hidden")
  }

  async save() {
    const metricName = this.nameInputTarget.value.trim()
    if (!metricName) {
      this.cancel()
      return
    }

    const body = {
      journey_map_card: {
        metric_name: metricName,
        metric_value: this.valueInputTarget.value || null,
        metric_format: this.formatSelectTarget.value,
        metric_previous_value: this.previousInputTarget.value || null,
        metric_target_value: this.targetInputTarget.value || null,
        metric_unit: this.unitInputTarget.value.trim() || null
      }
    }

    try {
      const response = await patch(`/workspace/journey_map_cards/${this.cardIdValue}`, {
        body: JSON.stringify(body),
        contentType: "application/json",
        responseKind: "json"
      })

      if (response.ok) {
        // Turbo Stream broadcast will replace the whole card
        window.Turbo.visit(window.location.href)
      }
    } catch (error) {
      console.error("Error saving metric card:", error)
    }

    this.cancel()
  }

  async destroy(event) {
    event.preventDefault()
    event.stopPropagation()

    if (!confirm("Remove this metric card?")) return

    try {
      const response = await destroy(`/workspace/journey_map_cards/${this.cardIdValue}`, {
        responseKind: "json"
      })

      if (response.ok) {
        this.element.remove()
      }
    } catch (error) {
      console.error("Error deleting metric card:", error)
    }
  }

  handleKeydown(event) {
    if (event.key === "Enter") {
      event.preventDefault()
      this.save()
    }
    if (event.key === "Escape") {
      this.cancel()
    }
  }
}
